
import { Blocks as ItemContainerBlocks, Page as ItemContainerPage, TypeConfig as ItemContainerTypeConfig } from './ItemContainer.jsx';
import { Tokens as ItemMetaTokens } from './ItemMeta.jsx';
import Name from '../utility/Name.jsx';
import * as Signature from '../common/Signature.jsx';
import * as Statement from './Statement.jsx';

const Blocks = {
    get: (group, data) => [
        {
            id: 'certificateSeparator',
            dataType: 'separator',
            display: 'Certificate of Authenticity',
            group
        },
        {
            id: Name.Block.Inventory.Container,
            component: ItemContainerPage,
            config: {
                Block: ItemContainerTypeConfig.panel.block(),
                Style: ItemContainerTypeConfig.panel.style(),
                Visibility: ItemContainerTypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: ItemContainerTypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Item Container',
            group,
            image: '',
            type: 'container'
        },
        {
            id: Name.Block.AuthenticityStatement,
            component: Statement.Component,
            config: {
                Block: Statement.TypeConfig.panel.block(),
                Style: Statement.TypeConfig.panel.style(),
            },
            display: 'Authenticity Statement',
            group,
            image: ''
        },
        {
            id: Name.Block.Signature,
            component: Signature.Component,
            config: {
                Block: Signature.TypeConfig.panel.block(true),
                Style: Signature.TypeConfig.panel.style(),
                Description: Signature.TypeConfig.panel.description(),
                Label: Signature.TypeConfig.panel.label(),
                Value: Signature.TypeConfig.panel.value()
            },
            display: 'Signature Line',
            group,
            image: ''
        }
    ]
};
const Content = {
    [Name.Block.Inventory.Container]: ItemContainerBlocks
};
const Tokens = {
    get: (id, data) => {
        switch (id) {
            case Name.Block.AuthenticityStatement:
                return Statement.Tokens();
            case Name.Block.Inventory.Meta:
                return ItemMetaTokens(data);
        }
    }
};

export {
    Blocks,
    Content,
    Tokens
}